import { useTranslation } from "react-i18next";

import { INSOLE_STATUS } from "~/api/insoles";
import type { InsoleStatus } from "~/api/insoles";
import { Badge } from "~/ui";

interface InsoleStatusBadgeProps {
  status: InsoleStatus;
}

export const InsoleStatusBadge = ({ status }: InsoleStatusBadgeProps) => {
  const { t } = useTranslation();

  const badgeMapping = {
    [INSOLE_STATUS.WORKING]: (
      <Badge text={t("insole_status.working")} type="solid" color="success" />
    ),
    [INSOLE_STATUS.BROKEN]: (
      <Badge text={t("insole_status.broken")} type="solid" color="error" />
    ),
  };

  return badgeMapping[status];
};
